import { render, staticRenderFns } from "./ProductsBody.vue?vue&type=template&id=3f736576&scoped=true&"
import script from "./ProductsBody.vue?vue&type=script&lang=js&"
export * from "./ProductsBody.vue?vue&type=script&lang=js&"
import style0 from "./ProductsBody.vue?vue&type=style&index=0&id=3f736576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f736576",
  null
  
)

export default component.exports